import { render } from "./OperatorsOptions.vue?vue&type=template&id=613e1071&scoped=true"
import script from "./OperatorsOptions.vue?vue&type=script&lang=js"
export * from "./OperatorsOptions.vue?vue&type=script&lang=js"

import "./OperatorsOptions.vue?vue&type=style&index=0&id=613e1071&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613e1071"]])

export default __exports__